<template>
  <svg width="1em" height="1em" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path
d="M34 4H14V44H34V4Z" fill="none" stroke="currentColor" stroke-width="4" stroke-linecap="round"
stroke-linejoin="round"
/><path d="M44 8H34V40H44V8Z" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" /><path d="M14 8H4V40H14V8Z" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" /></svg>
</template>